import { useClearCartAfterCountryChange } from '@/components/Checkout/_helpers/hooks/useClearCartAfterCountryChange'
import { useCloseMenusOnPageChange } from '@/lib/hooks/helpers/useCloseMenusOnPageChange'
import { useGetOverwriteTerms } from '@/lib/hooks/helpers/useGetOverwriteTerms'
import { useRtlDirection } from '@/lib/hooks/helpers/useRtlDirection'
import { useInitApp } from '@/lib/hooks/initializers/useInitApp'
import { useLaunchDarklyContext } from '@/lib/hooks/initializers/useLaunchDarklyContext'
import { useReAuthenticateUser } from '@/lib/hooks/initializers/useReAuthenticateUser'
import { useInitialReferrer } from '@/lib/hooks/mixpanel/useInitialReferrer'
import { useMixpanelProperties } from '@/lib/hooks/mixpanel/useMixpanelProperties'
import { useOldUserInitialize } from '@/lib/hooks/mixpanel/useOldUserInitialize'
import { useRefreshLoginState } from '@/lib/hooks/services/useRefreshLoginState'

export const AppInitializer = () => {
  useInitApp()
  useReAuthenticateUser()
  useRefreshLoginState()
  useCloseMenusOnPageChange()
  useClearCartAfterCountryChange()
  useGetOverwriteTerms()
  useRtlDirection()
  useInitialReferrer()
  useMixpanelProperties()
  useOldUserInitialize()
  useLaunchDarklyContext()

  return null
}
